import * as React from 'react'
import { styled } from 'styled-components'
import { RD } from '@packages/prelude'
import { Form } from 'react-bootstrap'
import type { SubmissionResult } from './PurchaseForm'
import { FormSubmit } from './FormSubmit'

const Label = styled(Form.Label)`
  font-family: var(--bs-font-sans-serif);
  font-size: 0.875rem;
  text-transform: uppercase;
  font-weight: bold;
  color: var(--bs-info);
`

const TextArea = styled(Form.Control)`
  background-color: var(--bs-white) !important;
  color: var(--bs-primary);
  border: 1px solid var(--bs-secondary);

  resize: none;

  min-height: 10rem;
  padding: 0.375rem 0.75rem;

  @media screen and (min-width: 768px) {
    border-width: 2px;
  }

  &:focus {
    border-color: #8b9faa;
    box-shadow: 0 0 0 0.25rem rgba(22, 63, 85, 0.25);
    color: #343434;
    outline: 0;
  }
`

interface RequestProps {
  submissionState: RD.RemoteData<Error, SubmissionResult>
  handleBack: () => void
}

export const Request: React.FC<RequestProps> = ({ submissionState, handleBack }) => {
  return (
    <FormSubmit
      title="Ihre Anfrage"
      submissionType="request"
      submissionState={submissionState}
      handleBack={handleBack}
      submitButtonText="Anfrage senden">
      <Form.Group className="d-flex flex-column">
        <Label htmlFor="request">Ihre Anfrage an uns:</Label>
        <TextArea as="textarea" id="request" name="request" placeholder="Was können wir für Sie tun?" required />
      </Form.Group>
    </FormSubmit>
  )
}
